import { useDispatch, useSelector } from "react-redux";
import AllEvents from "./AllEvents";
import ReactPlayer from "react-player";
import * as Icons from "@mui/icons-material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setMaximizeLibraryPage } from "../../../../Redux/Actions/VideoLibraryActions";
import { setVideoLibraryTableStateByName } from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
const Content = ({
  playing,
  setPlaying,
  videoSettings,
  setVideoSettings,
  zoomLevel,
  currentVideoIndex,
  setCurrentVideoIndex,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedVideo, filteredTableData } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  const { isMobileDevice } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const { maxLibraryPage } = useSelector((state) => state?.videoLibraryData);
  const { ChevronRight: ChevronRightIcon, ChevronLeft: ChevronLeftIcon } =
    Icons;
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1024px)");
  const isLaptop = useMediaQuery("(min-width:1025px) and (max-width:2000px)");
  const intercutPlaylist = (
    seasonName,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName,
    playlistId
  ) => {
    switch (seasonType) {
      case "In-Season":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event-type=${eventType}&week=${opponentName}&playlist-id=${playlistId}`
        );
        break;

      case "Off-Season":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event=${eventName}&practice=${practiceName}&playlist-id=${playlistId}`
        );
        break;

      case "Other":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event=${eventName}&playlist-id=${playlistId}`
        );
        break;

      default:
        break;
    }
  };

  const handleVideoEnd = () => {
    const nextVideoIndex =
      currentVideoIndex < filteredTableData.length - 1
        ? currentVideoIndex + 1
        : 0;
    const nextVideo = filteredTableData[nextVideoIndex];
    const nextRow = nextVideo?.row[0] || {}; //zero
    setCurrentVideoIndex(nextVideoIndex);
    setVideoLibraryTableStateByName(dispatch, {
      breakDownId: nextVideo?.id,
      rowId: nextRow?.id,
      changes: { focus: true },
      table: filteredTableData.length > 0 ? "filteredTableData" : "tableData",
    });
    setPlaying(true);
  };

  const handleReady = () => {
    if (currentVideoIndex === 0 && filteredTableData) {
      setVideoLibraryTableStateByName(dispatch, {
        breakDownId: filteredTableData[0]?.id,
        rowId: filteredTableData[0]?.row[0]?.id,
        changes: { focus: true },
        table: "filteredTableData",
      });
    }
  };
  return (
    <div className="center">
      {isLaptop && (
        <>
          <div
            className={
              videoSettings.fullHeight
                ? "centerLeft"
                : "centerLeft centerLeftHeight"
            }
          >
            {!selectedVideo?.videoPath && <span>No video selected</span>}
            <ReactPlayer
              id="videoPlayer"
              url={
                filteredTableData
                  ? filteredTableData[currentVideoIndex]?.eventMedia?.videoPath
                  : selectedVideo?.videoPath
              }
              playing={playing}
              onReady={handleReady}
              onEnded={
                filteredTableData ? handleVideoEnd : () => setPlaying(false)
              }
              onPause={() => setPlaying(false)}
              onPlay={() => setPlaying(true)}
              controls
              loop={filteredTableData ? false : true}
              width="100%"
              height="100%"
              style={{ transform: `scale(${zoomLevel})` }}
            />
            <div
              className="videoToggle"
              onClick={() => {
                setVideoSettings((prevState) => ({
                  ...prevState,
                  fullWidth: !prevState.fullWidth,
                }));
              }}
            >
              {videoSettings.fullWidth ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </div>
            <div
              className="videoRightToggle"
              onClick={() => {
                setMaximizeLibraryPage(dispatch, {
                  maxLibraryPage: !maxLibraryPage,
                });
              }}
            >
              {videoSettings.fullWidth ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </div>
          </div>
          <div
            className={`${
              videoSettings.fullWidth
                ? "centerRight"
                : "centerRight centerRightHidden"
            } ${!videoSettings.fullHeight && "centerRightHeight"} `}
          >
            <AllEvents
              intercutPlaylist={intercutPlaylist}
              setPlaying={setPlaying}
            />
          </div>
        </>
      )}
      {(isTablet || isMobileDevice) && (
        <>
          <div
            className={`${
              videoSettings.fullWidth
                ? "centerRight"
                : "centerRight centerRightHidden"
            } ${!videoSettings.fullHeight && "centerRightHeight"} `}
          >
            <AllEvents
              intercutPlaylist={intercutPlaylist}
              setPlaying={setPlaying}
            />
          </div>
          <div
            className={
              videoSettings.fullHeight
                ? "centerLeft"
                : "centerLeft centerLeftHeight pd-top-10"
            }
          >
            {!selectedVideo?.videoPath && <span>No video selected</span>}
            <ReactPlayer
              id="videoPlayer"
              url={
                filteredTableData
                  ? filteredTableData[currentVideoIndex]?.eventMedia?.videoPath
                  : selectedVideo?.videoPath
              }
              playing={playing}
              onReady={handleReady}
              onEnded={
                filteredTableData ? handleVideoEnd : () => setPlaying(false)
              }
              onPause={() => setPlaying(false)}
              onPlay={() => setPlaying(true)}
              controls
              loop={filteredTableData ? false : true}
              width="100%"
              height="100%"
              style={{ transform: `scale(${zoomLevel})` }}
            />
            <div
              className="videoToggle"
              onClick={() => {
                setVideoSettings((prevState) => ({
                  ...prevState,
                  fullWidth: !prevState.fullWidth,
                }));
              }}
            >
              {videoSettings.fullWidth ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </div>
            <div
              className="videoRightToggle"
              onClick={() => {
                setMaximizeLibraryPage(dispatch, {
                  maxLibraryPage: !maxLibraryPage,
                });
              }}
            >
              {videoSettings.fullWidth ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Content;
